<template>
  <div>
    <div class="mb-2 d-flex justify-content-between align-items-center">
      <h3>Purchases</h3>

      <div class="d-flex justify-content-between gap-20">
        <b-button @click="showAddPurchaseModal" variant="warning" class="add_button text-white">
          Add Purchase <i class="las la-plus ml-3"></i>
        </b-button>
      </div>
    </div>
    <main-table
      :fields="columns"
      class="mb-0 table-borderless"
      :items="items"
      :pagination-flag="false"
    >
      <template v-slot:num="data">
        {{data.data.row_number}}
      </template>

      <template v-slot:created_at="data">
        {{data.data.created_at ? data.data.created_at.substr(0,10) : '--'}}
      </template>

      <template v-slot:expire_date="data">
        <span v-if="data.data.child">---</span>
        <span v-else>{{data.data.expire_date ? getRemainingDays(data.data.expire_date) + ' Days' : '--'}}</span>
      </template>

      <template v-slot:quantity="data">
        <span v-if="data.data.quantity == 'infinity'">
          <i class="las la-infinity" style="transform: rotate(0deg)!important;"></i>
        </span>
        <span v-else>{{ data.data.quantity }}</span>
      </template>

    </main-table>

    <main-modal id="AddPurchaseModal">
      <template v-slot:header>
        <h4 class="font-weight-bold">
          <span class="text-warning" >Add: </span> Purchase
        </h4>
      </template>
      <template v-slot:body>
        <ManagementPurchasesAdd
          @addPurchase="addPurchase"
          :requestLoading="requestLoading"
        />
      </template>
    </main-modal>

    <main-modal id="ViewPurchaseModal">
      <template v-slot:header>
        <h4 class="font-weight-bold">
          <span class="text-success-light" >View: </span> Purchase
        </h4>
      </template>
      <template v-slot:body>
        <ManagementPurchasesView :details="purchaseDetails" />
      </template>
    </main-modal>

    <main-modal id="EditPurchaseModal">
      <template v-slot:header>
        <h4 class="font-weight-bold">
          <span class="text-info" >Edit: </span> Purchase
        </h4>
      </template>
      <template v-slot:body>
        <ManagementPurchasesEdit
          :info="purchaseDetails"
          :remaining="getRemainingDays(purchaseDetails.expire_date)"
          @editPurchase="editPurchase"
          :requestLoading="requestLoading"
        />
      </template>
    </main-modal>

    <main-modal id="CollectPurchaseModal">
      <template v-slot:header>
        <h4 class="font-weight-bold">
          <span class="text-warning" >Collect: </span> Purchase
        </h4>
      </template>
      <template v-slot:body>
        <ManagementPurchasesCollect
          @collectPurchase="collectPurchase"
          :info="purchaseDetails"
          :requestLoading="requestLoading"
        />
      </template>
    </main-modal>

    <main-modal id="RefundPurchaseModal">
      <template v-slot:header>
        <h4 class="font-weight-bold">
          <span class="text-danger" >Refund: </span> Purchase
        </h4>
      </template>
      <template v-slot:body>
        <ManagementPurchasesRefund
          @refundPurchase="refundPurchase"
          :requestLoading="requestLoading"
          :info="purchaseDetails"
        />
      </template>
    </main-modal>

    <main-modal id="CancelPurchaseModal">
      <template v-slot:header>
        <h4 class="font-weight-bold">
          <span class="text-danger" >Cancel: </span> Purchase
        </h4>
      </template>
      <template v-slot:body>
        <ManagementPurchasesCancel
          @cancelPurchase="cancelPurchase"
          :requestLoading="requestLoading"
          :info="purchaseDetails"
        />
      </template>
    </main-modal>
  </div>
</template>
<script>
import { core } from '@/config/pluginInit'
import ManagementPurchasesAdd from '../components/ManagementPurchasesAdd.vue'
import ManagementPurchasesView from '../components/ManagementPurchasesView.vue'
import ManagementPurchasesEdit from '../components/ManagementPurchasesEdit.vue'
import ManagementPurchasesCollect from '../components/ManagementPurchasesCollect.vue'
import ManagementPurchasesRefund from '../components/ManagementPurchasesRefund.vue'
import ManagementPurchasesCancel from '../components/ManagementPurchasesCancel.vue'
import managementServices from '../services/management.services'
export default {
  data () {
    return {
      items: [],
      requestLoading: false,
      purchaseDetails: {},
      columns: [
        { label: '#', key: 'num', class: 'text-left', type: 'custom' },
        { label: 'Date', key: 'created_at', class: 'text-left', type: 'custom' },
        { label: 'Type', key: 'type', class: 'text-left' },
        { label: 'Name', key: 'name', class: 'text-left text-bold' },
        { label: 'Quantity', key: 'quantity', class: 'text-left', type: 'custom' },
        { label: 'Amount', key: 'total_price', class: 'text-left' },
        { label: 'Status', key: 'status', class: 'text-left', type: 'status' },
        { label: 'Validity', key: 'expire_date', class: 'text-left', type: 'custom' },
        {
          label: 'Actions',
          key: 'actions',
          class: 'text-left',
          type: 'actions',
          actions: [
            {
              showIf: (data) => (data.status !== '--' && !data.child),
              icon: 'las la-eye',
              color: 'success-light',
              text: 'View',
              actionName: 'showViewPurchaseModal',
              actionParams: 'fullObj'
            },
            {
              showIf: (data) => (!data.child),
              icon: 'las la-pen',
              color: 'info',
              text: 'Edit',
              actionName: 'showEditPurchaseModal',
              actionParams: 'fullObj'
            },
            {
              showIf: (data) => (data.child || data.type === 'ticket'),
              icon: 'las la-coins',
              color: 'warning',
              text: 'Collect',
              actionName: 'showCollectPurchaseModal',
              actionParams: 'fullObj'
            },
            {
              showIf: (data) => !data.refund && !data.child,
              icon: 'las la-undo-alt',
              color: 'danger',
              text: 'Refund',
              actionName: 'showRefundPurchaseModal',
              actionParams: 'fullObj'
            },
            {
              showIf: (data) => !data.child,
              // showIf: (data) => (data.status === 'DUE'),
              icon: 'las la-times',
              color: 'danger',
              text: 'Cancel',
              actionName: 'showCancelPurchaseModal',
              actionParams: 'fullObj'
            }
          ]
        }
      ]
    }
  },
  components: {
    ManagementPurchasesAdd,
    ManagementPurchasesView,
    ManagementPurchasesEdit,
    ManagementPurchasesCollect,
    ManagementPurchasesRefund,
    ManagementPurchasesCancel
  },
  methods: {
    getAllPurchases () {
      managementServices.getAllPurchases(this.$route.params.id).then(response => {
        const data = response.data.data.data
        this.items = data.flatMap((item, parentIndex) => {
          const parentNumber = parentIndex + 1

          const parentRow = {
            ...item,
            child: false,
            row_number: `${parentNumber}`
          }

          if (item.type === 'ticket') {
            return [parentRow]
          }

          const childRows = (item.tickets || []).map((ticket, childIndex) => ({
            ...ticket,
            type: 'ticket',
            quantity: ticket.unlimited ? 'infinity'  : ticket.quantity,
            child: true,
            parent_id: item.id,
            parent_data: item,
            row_number: `${parentNumber}-${childIndex + 1}`
          }))

          return [parentRow, ...childRows]
        })

      })
    },

    getRemainingDays(dateString) {
    const today = new Date();
    const targetDate = new Date(dateString);

    today.setHours(0, 0, 0, 0);
    targetDate.setHours(0, 0, 0, 0);

    const diffTime = targetDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  },

  addPurchase (payload) {
      this.requestLoading = true
      managementServices.addNewPurchase(payload).then((res) => {
        this.getAllPurchases()
        core.showSnackbar('success', res.data.message)
        this.$bvModal.hide('AddPurchaseModal')
        this.requestLoading = false
      }).finally(() => {
        this.requestLoading = false
      })
    },
    editPurchase (data) {
      this.requestLoading = true
      managementServices.editPurchase(this.purchaseDetails.id, data).then((res) => {
        this.getAllPurchases()
        core.showSnackbar('success', res.data.message)
        this.$bvModal.hide('EditPurchaseModal')
        this.requestLoading = false
      })
    },
    collectPurchase (data) {
      this.requestLoading = true
      managementServices.collectPurchase(!this.purchaseDetails.child ? this.purchaseDetails.tickets?.[0]?.id : this.purchaseDetails.id, data).then((res) => {
        this.getAllPurchases()
        core.showSnackbar('success', res.data.message)
        this.$bvModal.hide('CollectPurchaseModal')
        this.requestLoading = false
      }).finally(() => {
        this.requestLoading = false
      })
    },
    refundPurchase (amount) {
      this.requestLoading = true
      managementServices.refundPurchase(this.purchaseDetails.id, amount).then((res) => {
        this.getAllPurchases()
        core.showSnackbar('success', res.data.message)
        this.$bvModal.hide('RefundPurchaseModal')
        this.requestLoading = false
      }).finally(() => {
        this.requestLoading = false
      })
    },
    cancelPurchase () {
      this.requestLoading = true
      managementServices.cancelPurchase(this.purchaseDetails.id).then((res) => {
        this.getAllPurchases()
        core.showSnackbar('success', res.data.message)
        this.$bvModal.hide('CancelPurchaseModal')
        this.requestLoading = false
      }).finally(() => {
        this.requestLoading = false
      })
    },

    showAddPurchaseModal () {
      this.$bvModal.show('AddPurchaseModal')
    },
    showViewPurchaseModal (obj) {
      this.purchaseDetails = obj
      this.$bvModal.show('ViewPurchaseModal')
    },
    showEditPurchaseModal (obj) {
      this.purchaseDetails = obj
      this.$bvModal.show('EditPurchaseModal')
    },
    showCollectPurchaseModal (obj) {
      this.purchaseDetails = obj
      this.$bvModal.show('CollectPurchaseModal')
    },
    showRefundPurchaseModal (obj) {
      this.purchaseDetails = obj
      this.$bvModal.show('RefundPurchaseModal')
    },
    showCancelPurchaseModal (obj) {
      this.purchaseDetails = obj
      this.$bvModal.show('CancelPurchaseModal')
    }
  },
  created () {
    this.$root.$on('showViewPurchaseModal', this.showViewPurchaseModal)
    this.$root.$on('showEditPurchaseModal', this.showEditPurchaseModal)
    this.$root.$on('showCollectPurchaseModal', this.showCollectPurchaseModal)
    this.$root.$on('showRefundPurchaseModal', this.showRefundPurchaseModal)
    this.$root.$on('showCancelPurchaseModal', this.showCancelPurchaseModal)
    this.getAllPurchases()
  },
  beforeDestroy () {
    this.$root.$off('showViewPurchaseModal')
    this.$root.$off('showEditPurchaseModal')
    this.$root.$off('showCollectPurchaseModal')
    this.$root.$off('showRefundPurchaseModal')
    this.$root.$off('showCancelPurchaseModal')
  },
  mounted () {
    core.index()
  }
}
</script>
